module.exports = __webpack_public_path__ + "static/media/student-game-comment-comment.83bfd7df.png";